import React from 'react';
import { FadeIn } from './FadeIn';
import { FileText, Star } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 lg:pt-40 lg:pb-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-86">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-87">
        <FadeIn direction="right" data-id="element-88">
          <div className="max-w-2xl" data-id="element-89">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-lightGray text-navy text-sm font-medium mb-6 border border-gray-200" data-id="element-90">
              <Star className="w-4 h-4 text-emerald" data-id="element-91" />
              <span data-id="element-92">Guía Estratégica para Profesionales</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-navy leading-[1.1] tracking-tight mb-6" data-id="element-93">
              ¿Te preparas para entrevistas pero sigues sin conseguir el puesto?
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-4 font-medium" data-id="element-94">
              El problema no siempre es tu experiencia. Muchas veces es que vas
              listo para responder, cuando en realidad deberías ir listo para
              conversar.
            </p>
            <p className="text-base sm:text-lg text-gray-500 mb-8" data-id="element-95">
              Descubre el método que transforma una entrevista en una
              conversación estratégica y te ayuda a destacar frente a otros
              candidatos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
              <a href="#offer" className="inline-flex justify-center items-center bg-emerald text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-emerald-hover transition-colors shadow-sm" data-id="element-97">
                Quiero destacar en mi próxima entrevista
              </a>
              <a href="#whats-inside" className="inline-flex justify-center items-center bg-white text-navy border-2 border-gray-200 px-8 py-4 rounded-lg font-bold text-lg hover:border-navy hover:bg-gray-50 transition-all" data-id="element-98">
                Ver lo que incluye la guía
              </a>
            </div>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-99">
          <div className="relative" data-id="element-100">
            <div className="absolute inset-0 bg-emerald/10 rounded-2xl transform translate-x-4 translate-y-4" data-id="element-101"></div>
            <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=1000" alt="Profesional segura en una entrevista" className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/3] lg:aspect-auto lg:h-[600px]" data-id="element-102" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 sm:bottom-8 sm:-left-12 bg-white p-4 rounded-xl shadow-lg border border-gray-100 flex items-center gap-4 animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-103">
              <div className="bg-emerald/10 p-3 rounded-lg" data-id="element-104">
                <FileText className="w-6 h-6 text-emerald" data-id="element-105" />
              </div>
              <div data-id="element-106">
                <p className="font-bold text-navy text-sm" data-id="element-107">
                  Guía PDF descargable
                </p>
                <p className="text-xs text-gray-500" data-id="element-108">Acceso inmediato</p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}